import {GenericAPI} from "./generic-api-client";

export default GenericAPI("schools");
